import React, { forwardRef, useEffect, useRef, useState } from "react";
import { MdPause, MdPlayArrow } from "react-icons/md";

const CustomAudioPlayer = forwardRef(
  ({ audioUrl, title, onPlay, onPause, isPlaying, setIsPlaying, currentAudio }, ref) => {
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);
    const audioRef = useRef(null);

    useEffect(() => {
      const audio = audioRef.current;

      if (audio) {
        // When currentAudio changes, stop the previous audio and reset
        if (currentAudio && audio.src !== audioUrl) {
          console.log("Switching to new audio");
          audio.pause();
          audio.currentTime = 0; // Reset previous audio
          setIsPlaying(false); // Reset the play state
        }

        // Play the new audio if isPlaying is true
        if (isPlaying && audio.src === audioUrl && audio.paused) {
          console.log("Playing audio:", title);
          audio
            .play()
            .then(() => {
              console.log("Audio playing");
            })
            .catch((error) => {
              console.error("Error playing audio:", error); // Handle any play errors
            });
        }
      }

      return () => {
        const audio = audioRef.current;
        if (audio) {
          audio.removeEventListener("loadedmetadata", handleLoadedMetadata);
        }
      };
    }, [audioUrl, currentAudio, isPlaying, setIsPlaying]);

    useEffect(() => {
      const audio = audioRef.current;
      if (audio) {
        audio.addEventListener("timeupdate", handleTimeUpdate);
      }

      return () => {
        const audio = audioRef.current;
        if (audio) {
          audio.removeEventListener("timeupdate", handleTimeUpdate);
        }
      };
    }, []);

    const handlePlayPause = () => {
      const audio = audioRef.current;
      if (isPlaying) {
        audio.pause();
        onPause && onPause(); // Trigger pause callback
      } else {
        audio
          .play()
          .then(() => {
            console.log("Audio is playing");
          })
          .catch((error) => {
            console.error("Error playing audio:", error);
          });
        onPlay && onPlay(); // Trigger play callback
      }
      setIsPlaying(!isPlaying); // Toggle the playing state
    };

    const handleTimeUpdate = () => {
      const audio = audioRef.current;
      setCurrentTime(audio.currentTime);
      setDuration(audio.duration);
    };

    const handleSeek = (e) => {
      const audio = audioRef.current;
      const newTime = (e.target.value / 100) * audio.duration;
      audio.currentTime = newTime;
    };

    const handleLoadedMetadata = () => {
      const audio = audioRef.current;
      setDuration(audio.duration);
    };

    return (
      <div className="audio-player">
        <audio ref={audioRef} src={audioUrl} />
        <div className="audio-info">
          <h4>{title}</h4>
          <div className="controls">
            <button onClick={handlePlayPause}>
              {isPlaying ? <MdPause size={24} /> : <MdPlayArrow size={24} />}
            </button>
          </div>
          <div className="progress-bar">
            <input type="range" value={(currentTime / duration) * 100 || 0} onChange={handleSeek} max="100" />
          </div>
        </div>
      </div>
    );
  }
);

export default CustomAudioPlayer;
